export const MAX_FREE_PROGRAMS = 1;

/**
 * How many more programs a user can create before hitting the free limit
 *
 * @param ownedProgramCount - Programs the user owns, wherever they live. Programs shared with the user are not counted. A NaN count is treated as the limit being used up.
 * @param isMember - Whether the user has member access
 * @returns Infinity for members, otherwise the remaining free programs (always between 0 and MAX_FREE_PROGRAMS)
 */
export const getRemainingFreePrograms = (
	ownedProgramCount: number,
	isMember: boolean,
): number => {
	if (isMember) {
		return Number.POSITIVE_INFINITY;
	}

	// Fail closed: a count that is not a number must never grant a program
	if (Number.isNaN(ownedProgramCount)) {
		return 0;
	}

	return Math.min(
		MAX_FREE_PROGRAMS,
		Math.max(0, MAX_FREE_PROGRAMS - ownedProgramCount),
	);
};
